<template>
  <BaseModal>
    <div class="modal-container">
      <section class="modal-success">
        <img
          class="modal-success__image"
          src="@/assets/img/checkmark_with_confetti.svg"
          alt="success-image"
        />
        <h2 class="modal-success__title">
          {{ $t('product_events.EVENT_CREATED') }}
        </h2>
      </section>
      <section class="modal-buttons">
        <router-link
          v-if="hasMandatoryOrOptionalPolicies"
          :to="{ name: ROUTE_PORTAL_LAYOUT }"
          class="modal-buttons__button-container"
        >
          <BaseButton
            outline
            class="modal-buttons__button"
            size="large"
            tabindex="-1"
          >
            {{ $t('product.PRODUCT_PUBLISH') }}
          </BaseButton>
        </router-link>

        <router-link
          :to="{ name: ROUTE_EDIT_EVENT, params: { productId } }"
          class="modal-buttons__button-container"
        >
          <BaseButton
            class="modal-buttons__button"
            theme="blue"
            size="large"
            tabindex="-1"
          >
            {{ $t('events.GO_TO_EVENT') }}
          </BaseButton>
        </router-link>
      </section>
    </div>
  </BaseModal>
</template>

<script>
import {
  ROUTE_PORTAL_LAYOUT,
  ROUTE_EVENTS,
  ROUTE_EDIT_EVENT,
} from '@/router/routes/routeNames'
import BaseButton from '@/components/generics/base/BaseButton.vue'
import BaseModal from '@/components/generics/base/BaseModal.vue'

export default {
  components: {
    BaseButton,
    BaseModal,
  },
  props: {
    policies: {
      type: Array,
      required: false,
      default: () => [],
    },
    productId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      ROUTE_PORTAL_LAYOUT,
      ROUTE_EVENTS,
      ROUTE_EDIT_EVENT,
    }
  },
  computed: {
    hasMandatoryOrOptionalPolicies() {
      return this.policies.some((policy) => {
        return policy.value === 'optional' || policy.state === 'mandatory'
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: $spacing-xl;
  text-align: center;
}
.modal-success {
  margin-bottom: $spacing-2xl;

  &__image {
    width: 356px;
    visibility: hidden;
    animation: pop-up 400ms forwards ease-in;
    animation-delay: 400ms;
    z-index: 10;
  }
  &__title {
    @include subtitle;
    font-size: $font-size-3xl;
    margin-top: $spacing-s;
    visibility: hidden;
    animation: fade-in 800ms forwards ease;
    animation-delay: 700ms;
  }
}
.modal-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: $spacing-s;
  width: 100%;
  opacity: 0;
  animation: fade-in 400ms forwards ease-in;
  animation-delay: 900ms;
}

@media screen and (max-width: $tablet-width-max) {
  .modal-buttons {
    flex-direction: column;
    gap: $spacing-2xs;

    &__button-container {
      width: 100%;
    }

    &__button {
      width: 100%;
    }
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
    visibility: visible;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes pop-up {
  0% {
    opacity: 0;
    transform: scale(0.5);
    visibility: visible;
  }
  80% {
    opacity: 1;
    transform: scale(1.1);
    visibility: visible;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    visibility: visible;
  }
}
</style>
